import React from 'react';
import styled from 'styled-components';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import Banner from 'components/ui/Banner';
import { iconColors } from 'helpers/ColorHelper';

import { getTranslatedString } from 'helpers/i18n';

const StyledSectionContainer = styled.div`
  margin-bottom: 24px;
`;

const affectedStatuses = [
  {
    status: 'proposed_scheduled_date',
    description: 'landlordPortal.maintenance.banner.ticketRequiresAction.description.scheduled',
    agentDescription:
      'landlordPortal.maintenance.banner.ticketRequiresAction.agentDescription.scheduled',
  },
  {
    status: 'contractor needed review',
    description: 'landlordPortal.maintenance.banner.ticketRequiresAction.description.contractor',
    agentDescription:
      'landlordPortal.maintenance.banner.ticketRequiresAction.agentDescription.contractor',
  },
  {
    status: 'parts needed review',
    description: 'landlordPortal.maintenance.banner.ticketRequiresAction.description.parts',
    agentDescription:
      'landlordPortal.maintenance.banner.ticketRequiresAction.agentDescription.parts',
  },
];

const BannerMessage = ({ values, userIsMaintenance, errors, touched, handleChange }) => {
  if (!values.status) return null;
  const statusDetails = affectedStatuses.find(
    statusInfo => statusInfo.status === values.status.toLowerCase()
  );
  if (!statusDetails) return null;

  return (
    <StyledSectionContainer>
      <Banner
        message={getTranslatedString(
          `landlordPortal.maintenance.banner.ticketRequiresAction.${userIsMaintenance
            ? 'message'
            : 'agentMessage'}`
        )}
        description={getTranslatedString(
          userIsMaintenance ? statusDetails.description : statusDetails.agentDescription
        )}
        closable
        showIcon
        icon={<ExclamationCircleOutlined style={{ color: iconColors.EXCLAMATION_CIRCLE_FILLED }} />}
      />
    </StyledSectionContainer>
  );
};

export default BannerMessage;
